module.exports = __webpack_public_path__ + "static/media/f1.c96ba425.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Feather/f1.png
// module id = 1212
// module chunks = 0